import useView, { ViewProvider } from "./context";

export default useView;

export { ViewProvider };
